import script from "./UserDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserDetails.vue?vue&type=script&lang=ts&setup=true"

import "./UserDetails.vue?vue&type=style&index=0&id=712d8332&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-712d8332"]])

export default __exports__